import { render, staticRenderFns } from "./Prefooter.vue?vue&type=template&id=ef1959d4&scoped=true&"
import script from "./Prefooter.vue?vue&type=script&lang=js&"
export * from "./Prefooter.vue?vue&type=script&lang=js&"
import style0 from "./Prefooter.vue?vue&type=style&index=0&id=ef1959d4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef1959d4",
  null
  
)

export default component.exports